import { type JSX,MouseEventHandler } from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { TooltipIcon } from 'common/components/TooltipIcon';

type RefreshButtonProps = {
    onClickHandler?: MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
};

export function RefreshButton({
    onClickHandler,
    disabled = false,
}: Readonly<RefreshButtonProps>): JSX.Element {
    const theme = useTheme();
    const refreshIconTooltipDescription = 'Refresh Table';
    const BUTTON_TEST_ID = 'refresh-data-grid-button-test-id';

    const refreshIconWithTooltip = (
        <TooltipIcon
            IconComponent={RefreshIcon}
            tooltipTitle={refreshIconTooltipDescription}
            iconColor='primary'
            iconInlineStyles={{ color: theme.palette.primary.accent as string }}
        />
    );
    return (
        <Button
            sx={{
                padding: '4px',
                minWidth: 'auto',
                marginRight: '1.5rem',
                border: null,
                backgroundColor: 'transparent'
            }}
            onClick={onClickHandler}
            disabled={disabled}
            data-testid={BUTTON_TEST_ID}
        >
            {refreshIconWithTooltip}
        </Button>
    );
}
